import React, { useState, useEffect } from "react"

import { FormControl, FormHelperText, FormLabel, Select, Option, Box, CircularProgress, ListDivider, Typography } from "@mui/joy";
import { Controller } from "react-hook-form";
import { Icon } from '../../assets';
import { useTranslation } from 'react-i18next';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useSelectOptions } from "src/mtska-frontend-app-component/utils/SelectOptions";

const InputSelect = ({ editing, required, name, control, label, autoFocus, placeholder, type = "select", hint, icon, disabled, readonly, addEmptyOption = false, haserror, options, translateOptions = true, className = "", dataProvider, project, labelkey, filters = {}, sort = [] }) => {
    const { t } = useTranslation();
    const [finalOptions, setFinalOptions] = useState();
    const [drawableOptions, setDrawableOptions] = useState();
    const [items, setItems] = useState();

    const { getSelectOptions } = useSelectOptions();

    if (!editing) readonly = true;
    if (readonly) disabled = true;
    const { loadAll } = useDataProvider(dataProvider);

    useEffect(() => {
        if (!dataProvider) return

        const fetch = async () => {
            try {
                const compoundfilters = {};
                compoundfilters.items = filters?.items ?? [];
                compoundfilters.project = project ?? [];
                
                //compoundfilters.sort = sort ?? [];

                loadAll(compoundfilters, sort ?? []).then((res) => {
                    setItems(res.items.data);
                })
            } catch (e) {
                console.error('Errore nel caricamento dei dati:', e)
            }
        }

        fetch()
    }, [dataProvider])


    useEffect(() => {
        if (!options || (Array.isArray(options) && options.length == 0)) return;

        setFinalOptions(options);
    }, [options])

    useEffect(() => {
        if (!items || (Array.isArray(items) && items.length == 0)) return;

        const opt = items.map((item) => ({
            value: item.value ?? item.id,
            label: item[labelkey] ?? item.name ?? item.id
        }));

        setFinalOptions(opt);
    }, [items])

    useEffect(() => {
        if (!finalOptions) return;

        const drwOpt = getSelectOptions(finalOptions);

        setDrawableOptions(drwOpt);
    }, [finalOptions, translateOptions, t]);

    return (
        !finalOptions ? <Box className="form-element form-element-calendar-booking-widget col-12"><CircularProgress /></Box> :
            <Controller
                name={name}
                control={control}
                render={({
                    field: { onChange, value, name },
                    fieldState: { error, invalid },
                    formState,
                }) => {
                    let generalClass = "form-element-control";
                    generalClass += (editing) ? " editing" : " reading";
                    generalClass += (invalid) ? " error" : "";
                    generalClass += (required) ? " required" : "";
                    generalClass += (disabled) ? " disabled" : "";
                    generalClass += (readonly) ? " readonly" : "";

                    if (typeof value == typeof undefined) {
                        className = className.replace(' filled', '').replace(' empty', '') + ' empty';
                    } else {
                        className = className.replace(' filled', '').replace(' empty', '') + ' filled';
                    }

                    return (
                        <div className={("form-element select " + className).trim()}>
                            <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                                <FormLabel className="form-element-label" htmlFor={name}>{t(label)}</FormLabel>
                                <Select
                                    id={name}
                                    type={type}
                                    name={name}
                                    value={value}
                                    error={invalid}
                                    onChange={(e, v) => { onChange(v); }}
                                    variant="outlined"
                                    autoComplete="off"
                                    className="form-element-field form-element-field-select"

                                    autoFocus={autoFocus}
                                    placeholder={t(placeholder)}
                                    disabled={disabled}
                                    readOnly={readonly}
                                    required={required}

                                    startDecorator={(icon) ? (
                                        <Icon icon={icon} />
                                    ) : (
                                        <></>
                                    )}
                                    endDecorator={(haserror || error) ? (
                                        <Icon icon="faCircleExclamation" />
                                    ) : (
                                        <></>
                                    )}
                                >
                                    {addEmptyOption && (
                                        <Option value="">Select</Option>
                                    )}
                                    {drawableOptions}
                                </Select>
                                <FormHelperText className="form-element-hint">
                                    {(haserror || error) ? (
                                        <>
                                            {error ? error.message : 'Messaggio di errore'}
                                        </>
                                    ) : (
                                        <>
                                            {hint}
                                        </>
                                    )}
                                </FormHelperText>
                            </FormControl>
                        </div>
                    )
                }}
            />

    );
};

export default InputSelect;